/**
 * Чистый класс продукта, является отражением продукта генерируемого сервером
 */
import store from "@/store";
import { Client } from "./profile";
import gaussRound from './gaussRound';

export interface ProductCert {
    name: string
    link: string
    size: number
    // Ссылка на запись в реестре Росаккредитации
    accreditationUrl?: string | null
    // true — товар не требует обязательной сертификации; exemptLabel — текст пометки
    exempt?: boolean
    exemptLabel?: string | null
}

export type sProducts = sProduct[]
export type Products = Product[]

export interface UpdateProductCountEvent {
    vCode: string,
    count: number
}

export abstract class sProduct {
    Артикул: string = ''
    Наименование: string = ''
    Наличие: number = 0
    quantity: number = 1
    selected?: boolean
    ЦенаОт0До3: number = 0
    ЦенаОт4До14: number = 0
    ЦенаОт15До366: number = 0
    Распродажа: number = 0
    ТорговаяМарка: string = ''
    ВидНоменклатуры: string = ''
    ЦеноваяГруппа: string = ''
    Фото: string = ''
    кор: string = ''
    уп: string = ''
    cert: null | ProductCert = null
    АналогИД: string = ''

    ТекстовоеОписание: string = ''
    ГруппаСписка: string = ''

    ШтукВУпаковке: string = ''
    ШтукаВес: string = ''
    ШтукаВесИзм: string = ''
    ШтукаВысота: string = ''
    ШтукаВысотаИзм: string = ''
    ШтукаДлина: string = ''
    ШтукаДлинаИзм: string = ''
    ШтукаОбъем: string = ''
    ШтукаОбъемИзм: string = ''
    ШтукаШирина: string = ''
    ШтукаШиринаИзм: string = ''

    УпаковкаВес: string = '' 
    УпаковкаВесИзм: string = ''
    УпаковкаВысота: string = ''
    УпаковкаВысотаИзм: string = ''
    УпаковкаГлубина: string = ''
    УпаковкаГлубинаИзм: string = ''
    УпаковкаОбъем: string = ''
    УпаковкаОбъемИзм: string = ''
    УпаковкаШирина: string = ''
    УпаковкаШиринаИзм: string = ''
    УпаковокВКоробке: string = ''

    КоробкаВес: string = ''
    КоробкаВесИзм: string = ''
    КоробкаВысота: string = ''
    КоробкаВысотаИзм: string = ''
    КоробкаГлубина: string = ''
    КоробкаГлубинаИзм: string = ''
    КоробкаОбъем: string = ''
    КоробкаОбъемИзм: string = ''
    КоробкаШирина: string = ''
    КоробкаШиринаИзм: string = ''

    constructor({
        Артикул = '',
        Наименование = '',
        Наличие = 0,
        quantity = 1,
        ЦенаОт0До3 = 0,
        ЦенаОт4До14 = 0,
        ЦенаОт15До366 = 0,
        Распродажа = 0,
        ТорговаяМарка = '',
        ВидНоменклатуры = '',
        ЦеноваяГруппа = '',
        Фото = '',
        кор = '',
        уп = '',
        cert = null,
        АналогИД = '',

        ТекстовоеОписание = '',
        ГруппаСписка = '',

        ШтукВУпаковке= '',
        ШтукаВес = '',
        ШтукаВесИзм  = '',
        ШтукаВысота = '',
        ШтукаВысотаИзм = '',
        ШтукаДлина = '',
        ШтукаДлинаИзм = '',
        ШтукаОбъем = '',
        ШтукаОбъемИзм = '',
        ШтукаШирина = '',
        ШтукаШиринаИзм = '',

        УпаковкаВес = '' ,
        УпаковкаВесИзм = '',
        УпаковкаВысота = '',
        УпаковкаВысотаИзм = '',
        УпаковкаГлубина = '',
        УпаковкаГлубинаИзм = '',
        УпаковкаОбъем = '',
        УпаковкаОбъемИзм = '',
        УпаковкаШирина = '',
        УпаковкаШиринаИзм = '',
        УпаковокВКоробке = '',

        КоробкаВес = '',
        КоробкаВесИзм = '',
        КоробкаВысота = '',
        КоробкаВысотаИзм = '',
        КоробкаГлубина = '',
        КоробкаГлубинаИзм = '',
        КоробкаОбъем = '',
        КоробкаОбъемИзм = '',
        КоробкаШирина = '',
        КоробкаШиринаИзм  = '',
    }: sProduct) {
        this.Артикул = Артикул
        this.Наименование = Наименование
        this.Наличие = +(Наличие + '').replace(/\s/g, '')
        this.quantity = +quantity
        this.ЦенаОт0До3 = ЦенаОт0До3 ? +ЦенаОт0До3 : 0
        this.ЦенаОт4До14 = ЦенаОт4До14 ? +ЦенаОт4До14 : 0
        this.ЦенаОт15До366 = ЦенаОт15До366 ? +ЦенаОт15До366 : 0
        this.Распродажа = Распродажа ? +Распродажа : 0
        this.ТорговаяМарка = ТорговаяМарка
        this.ВидНоменклатуры = ВидНоменклатуры
        this.ЦеноваяГруппа = ЦеноваяГруппа
        this.Фото = Фото
        this.кор = кор
        this.уп = уп
        this.cert = cert
        this.АналогИД = АналогИД

        this.ТекстовоеОписание = ТекстовоеОписание
        this.ГруппаСписка = ГруппаСписка

        this.ШтукВУпаковке = ШтукВУпаковке
        this.ШтукаВес = ШтукаВес
        this.ШтукаВесИзм  = ШтукаВесИзм
        this.ШтукаВысота = ШтукаВысота
        this.ШтукаВысотаИзм = ШтукаВысотаИзм
        this.ШтукаДлина = ШтукаДлина
        this.ШтукаДлинаИзм = ШтукаДлинаИзм
        this.ШтукаОбъем = ШтукаОбъем
        this.ШтукаОбъемИзм = ШтукаОбъемИзм
        this.ШтукаШирина = ШтукаШирина
        this.ШтукаШиринаИзм = ШтукаШиринаИзм

        this.УпаковкаВес = УпаковкаВес
        this.УпаковкаВесИзм = УпаковкаВесИзм
        this.УпаковкаВысота = УпаковкаВысота
        this.УпаковкаВысотаИзм = УпаковкаВысотаИзм
        this.УпаковкаГлубина = УпаковкаГлубина
        this.УпаковкаГлубинаИзм = УпаковкаГлубинаИзм
        this.УпаковкаОбъем = УпаковкаОбъем
        this.УпаковкаОбъемИзм = УпаковкаОбъемИзм
        this.УпаковкаШирина = УпаковкаШирина
        this.УпаковкаШиринаИзм = УпаковкаШиринаИзм
        this.УпаковокВКоробке = УпаковокВКоробке

        this.КоробкаВес = КоробкаВес
        this.КоробкаВесИзм = КоробкаВесИзм
        this.КоробкаВысота = КоробкаВысота
        this.КоробкаВысотаИзм = КоробкаВысотаИзм
        this.КоробкаГлубина = КоробкаГлубина
        this.КоробкаГлубинаИзм = КоробкаГлубинаИзм
        this.КоробкаОбъем = КоробкаОбъем
        this.КоробкаОбъемИзм = КоробкаОбъемИзм
        this.КоробкаШирина = КоробкаШирина
        this.КоробкаШиринаИзм  = КоробкаШиринаИзм
    }
}

export class sfProduct extends sProduct {
    Description = ''
    PhotoList: string[] = []
}

export class Product extends sProduct {
    quantity: number = 1
    selected: boolean = false
    get id() {
        return this.Артикул
    }
    get По_факту() {
        return this.quantity > this.Наличие ? this.Наличие : this.quantity;
    }
    get formattedAvailability() {
        return (new Intl.NumberFormat('ru', {
            maximumFractionDigits: 0
        })).format(this.Наличие);
    }
    get original_price() {
        let cost = this.ЦенаОт15До366 ? this.ЦенаОт15До366 : 0;
        let client: Client = (store.state as any).profile.clientInfo;

        if (this.Распродажа) return this.Распродажа;

        if (client.c1code) {
            let otgr = client.otgr;

            if (client.price_matrix[this.Артикул]) return client.price_matrix[this.Артикул].Цена;

            switch (otgr) {
                case -1:
                    cost = this.ЦенаОт0До3 ? this.ЦенаОт0До3 : this.ЦенаОт15До366
                    break
                case 0:
                    cost = this.ЦенаОт0До3 ? this.ЦенаОт0До3 : this.ЦенаОт15До366
                    break
                case 1:
                    cost = this.ЦенаОт0До3 ? this.ЦенаОт0До3 : this.ЦенаОт15До366
                    break
                case 2:
                    cost = this.ЦенаОт4До14 ? this.ЦенаОт4До14 : this.ЦенаОт15До366
                    break
                case 3:
                    cost = this.ЦенаОт15До366 ? this.ЦенаОт15До366 : this.ЦенаОт0До3
                    break
                default:
                    break;
            }

            switch (this.ЦеноваяГруппа) {
                case 'Россия':
                    if (+client.sale_rus) cost = gaussRound((100 - +client.sale_rus) / 100 * +cost, 2);
                    break;
                case 'Импорт':
                    if (+client.sale_imp) cost = gaussRound((100 - +client.sale_imp) / 100 * +cost, 2);
                    break;
                case 'Электроинструмент':
                    if (+client.sale_elec) cost = gaussRound((100 - +client.sale_elec) / 100 * +cost, 2);
                    break;
                default:
                    break;
            }
        }

        return cost;
    }
    get Учетная() {
        return (new Intl.NumberFormat('ru', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })).format(this.original_price);
    }
    get line_price() {
        return (new Intl.NumberFormat('ru', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })).format(this.original_line_price);
    }
    get original_line_price() {
        return gaussRound(this.quantity * this.original_price, 2)
    }
    get Цена_по_факту() {
        return gaussRound(this.По_факту * this.original_price, 2)
    }
    get unsecured_price() {
        return gaussRound(this.original_line_price - this.Цена_по_факту, 2)
    }
    constructor(sproduct: sProduct) {
        super(sproduct)
        if (sproduct.quantity) this.quantity = sproduct.quantity
        this.selected = sproduct.selected !== false
    }
    toJSON() {
        const jsonObj: any = Object.assign({}, this);
        const proto = Object.getPrototypeOf(this);
        for (const key of Object.getOwnPropertyNames(proto)) {
            const desc = Object.getOwnPropertyDescriptor(proto, key);
            const hasGetter = desc && typeof desc.get === 'function';
            if (hasGetter) {
                jsonObj[key] = (this as any)[key];
            }
        }
        return jsonObj;
    }
}
/**
 * only for single product page
 */
export class fProduct extends Product {
    Description: string = ''
    PhotoList: string[] = []
    constructor(product: sfProduct) {
        super(product)
        this.Description = product.Description
        // Без пустых ссылок: по длине списка решается, показывать ли кнопку скачивания архива
        this.PhotoList = (product.PhotoList || []).filter(Boolean)
    }
}

export function sProductsToProducts(sproducts: sProducts) {
    return sproducts.map((sproduct) => new Product(sproduct))
}
